import pc from "picocolors";

export const highlighter = {
  error: pc.red,
  warn: pc.yellow,
  info: pc.cyan,
  success: pc.green,
  dim: pc.dim,
  bold: pc.bold,
  brand: pc.magenta,
};
